import { CircularProgress } from '@mui/material';
import Grid from '@mui/material/Grid';

export default function ViewLoader(){
    return (
        <Grid container>
            <Grid size={{ xs: 12 }} style={{textAlign: 'center'}}>
                <CircularProgress />
            </Grid>
        </Grid>
    )
}